import React from 'react';
import '../styling/animation.css';

const colors = {
  cardboard: '#c19a6c',
  parcelBlue: '#146EB4',
  parcelOrange: '#f8bd19',
  conveyorBelt: '#3f4a59',
};

export const Animation = ({finishAnimation}: { finishAnimation?: boolean }) => (
  <svg id="parcelAnimation" className={finishAnimation? "hidden": ""} viewBox="0 60 980 180" xmlns="http://www.w3.org/2000/svg" fill="none">
    <defs>
      <g id="amazonParcel" transform="scale(0.5)">
        <rect width="132" height=" 132" x="26" y="30" fill={colors.cardboard} stroke="black" strokeWidth="3" rx="16" />
        <path stroke="black" fill={colors.parcelBlue} strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
          d="M72 31.5v38l20-10 20 10V31.5" />
        <path stroke={colors.parcelOrange} strokeLinecap="round" strokeLinejoin="round" strokeWidth="6"
          d="M51 110s18 12 42 12 42-12 42-12m0 0-17-7m17 7-7 19" />
      </g>
      <g id="beltBlock">
        <rect width="10" height="5" x="0" y="2" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
        <rect width="10" height="5" x="20" y="2" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
        <rect width="10" height="5" x="40" y="2" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
        <rect width="10" height="5" x="60" y="2" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
        <rect width="10" height="5" x="80" y="2" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
        <rect width="10" height="5" x="100" y="2" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
        <rect width="10" height="5" x="120" y="2" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
        <rect width="140" height="10" y="5" stroke={colors.conveyorBelt} fill={colors.conveyorBelt} />
      </g>
    </defs>

    <rect width="100%" height="100%" fill="white" />

    <g id="conveyorBelt">
      <use id="beltBlock0" x="0" y="230" href="#beltBlock" />
      <use id="beltBlock1" x="140" y="230" href="#beltBlock" />
      <use id="beltBlock2" x="280" y="230" href="#beltBlock" />
      <use id="beltBlock3" x="420" y="230" href="#beltBlock" />
      <use id="beltBlock4" x="560" y="230" href="#beltBlock" />
      <use id="beltBlock5" x="700" y="230" href="#beltBlock" />
      <use id="beltBlock6" x="840" y="230" href="#beltBlock" />
      <use id="beltBlock5" x="980" y="230" href="#beltBlock" />
      <use id="beltBlock6" x="1120" y="230" href="#beltBlock" />

      <g className="parcelEven">
        <use id="parcel0" className='parcelInner' x="0" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelOdd">
        <use id="parcel1" className='parcelInner' x="140" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelEven">
        <use id="parcel2" className='parcelInner' x="280" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelOdd">
        <use id="parcel3" className='parcelInner' x="420" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelEven">
        <use id="parcel4" className='parcelInner' x="560" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelOdd">
        <use id="parcel5" className='parcelInner' x="700" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelEven">
        <use id="parcel6" className='parcelInner' x="840" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelOdd">
        <use id="parcel7" className='parcelInner' x="980" y="150" href="#amazonParcel" />
      </g>
      <g className="parcelEven">
        <use id="parcel8" className='parcelInner' x="1120" y="150" href="#amazonParcel" />
      </g>
    </g>
  </svg>
)